import React, { useEffect } from 'react';
const AdsComponents = ({ adClient, adSlot, adFormat,responsive}) => {
    useEffect(() => {
        (window.adsbygoogle = window.adsbygoogle || []).push({});
      }, []);
  return (
    <ins className="adsbygoogle"
         style={{ display: 'block' }}
         data-ad-client={adClient}
         data-ad-slot={adSlot}
         data-ad-format={adFormat}
         data-full-width-responsive={responsive}
         ></ins>
  )
}

export default AdsComponents
